import { cn } from '@/lib/utils'
import styles from './skeleton.module.scss'
import React from 'react'

function Skeleton({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn('tw-bg-muted', styles.skeleton, className)} {...props} />
}

export { Skeleton }
